// apps/share-web/src/chart/chart-fit.ts
//
// «Вся песня на экране» (words page v2): подобрать колонки и размер так, чтобы
// лист поместился в экран целиком, без прокрутки. Сергей: «мне нравится режим
// полной песни, когда ты нажимаешь просто, и оно тебе всё показывает на одном
// экране, вмещает».
//
// Чистый перебор. Порядок кандидатов — сначала больше колонок при ТЕКУЩЕМ
// размере, потом мельче: колонки дешевле для глаз, чем уменьшенный кегль.
// Мерить умеет только слой (нужна раскладка), поэтому ответ «помещается?»
// приходит швом `fits(columns, fontPct)`; первый положительный — план. Ниже
// FIT_FLOOR_PCT не идём: дальше строки чарта не читаются.
//
// Пол АБСОЛЮТНЫЙ (от базы поверхности), а не от размера читателя: замер живьём
// 14.09 — читатель с +50 % включал режим на длинной песне, относительный пол
// (+10 %) не давал ни одного варианта, и «вся песня» честно говорила «не
// помещается» там, где при +0…−40 поместилась бы.

import { clampFontPct, FONT_PCT_STEP } from './chart-font.js';
import { READER_COLUMNS_MAX } from './reader-prefs.js';

/** Ниже этого размера подбор не идёт: −40 % ≈ 9 px на базе панели 15 px. */
export const FIT_FLOOR_PCT = -40;

export interface FitPlan { columns: number; fontPct: number; }

export interface PlanFitArgs {
  /** Настройки читателя — точка отсчёта: перебор идёт от них вниз по размеру и вверх по колонкам. */
  columns: number;
  fontPct: number;
  /** Померить кандидата. Зовётся по порядку; первый true — ответ. */
  fits: (columns: number, fontPct: number) => boolean;
}

/** null — не помещается ни в одном сочетании; лист остаётся на настройках читателя. */
export function planFit(args: PlanFitArgs): FitPlan | null {
  const startCols = Math.max(1, Math.min(READER_COLUMNS_MAX, Math.round(args.columns) || 1));
  const startPct = clampFontPct(args.fontPct);
  const floor = Math.min(startPct, clampFontPct(FIT_FLOOR_PCT));
  for (let pct = startPct; pct >= floor; pct -= FONT_PCT_STEP) {
    for (let cols = startCols; cols <= READER_COLUMNS_MAX; cols++) {
      if (args.fits(cols, pct)) return { columns: cols, fontPct: pct };
    }
  }
  return null;
}
